import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { H6 } from "../../../../AbstractElements";
import { ProjectAddressApi, ProjectApi } from "../../../../api";
import { CardBody } from "reactstrap";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Popconfirm,
  Row,
  Space,
  Table,
  Tag,
} from "antd";
import { PlusCircle } from "react-feather";
import TextArea from "antd/lib/input/TextArea";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import ProjectEdit from "./projectEdit";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Profile = (props) => {
  const [projectDetails, setProjectDetails] = useState(null);
  const [projectAddress, setProjectAddress] = useState([]);
  const [editId, setEditId] = useState(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    fetchProjectDetails();
    fetchProjectAddress({ project: props.settings.project.id });
  }, []);
  const showDrawer = () => {
    setVisible(true);
  };
  const formRef = useRef();
  const onClose = () => {
    setEditId(null);
    formRef.current.resetFields();
    setVisible(false);
  };
  const fetchProjectDetails = () => {
    // axios.get(`${ProjectApi}${props.settings.project.id}/`).then((res) => {
    //   setProjectDetails(res.data);
    // });
  };
  const fetchProjectAddress = (params = {}) => {
    axios.get(`${ProjectAddressApi}`, { params: { ...params } }).then((res) => {
      setProjectAddress(res.data);
    });
  };
  const onUpdate = (id) => {
    setEditId(id);
    setVisible(true);
    axios.get(`${ProjectAddressApi}${id}/`).then((res) => {
      formRef?.current?.setFieldsValue({
        label: res.data.label,
        address: res.data.address,
        city: res.data.city,
        pincode: res.data.pincode,
        contact_person: res?.data?.contact_person,
        contact_phone: res?.data?.contact_phone,
        contact_email: res?.data?.contact_email,
        gst_no: res?.data?.gst_no,
        pan_no: res?.data?.pan_no,
      });
    });
  };
  const onDelete = (id) => {
    axios
      .delete(`${ProjectAddressApi}${id}/`)
      .then((res) => {
        toast.success("Address deleted successfully");
        fetchProjectAddress({ project: props.settings.project.id });
      })
      .catch((res) => {});
  };
  const columns = [
    {
      title: "Address Label",
      key: "label",
      dataIndex: "label",
    },
    {
      title: "Address",
      key: "address",
      dataIndex: "address",
    },
    {
      title: "City",
      key: "city",
      dataIndex: "city",
    },
    {
      title: "Pincode",
      key: "pincode",
      dataIndex: "pincode",
    },
    {
      title: "Actions",
      key: "action",
      render: (data) => (
        <Space>
          <Tag
            onClick={() => {
              onUpdate(data.id);
            }}
            color={"warning"}
          >
            Edit Details
          </Tag>
          <Popconfirm
            okText="Yes"
            cancelText="No"
            title="Are you sure to delete?"
            onConfirm={() => onDelete(data.id)}
          >
            <Tag color="error">Delete</Tag>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const addAddress = () => {
    const updatedValues = formRef.current.getFieldsValue();

    if (
      !updatedValues.label ||
      !updatedValues.address ||
      !updatedValues.city ||
      !updatedValues.pincode
    ) {
      toast.error("Please fill all the fields");
      return false;
    }

    const values = new FormData();
    values.append("label", updatedValues.label ?? "");
    values.append("city", updatedValues.city ?? "");
    values.append("pincode", updatedValues.pincode ?? "");
    values.append("address", updatedValues.address ?? "");
    values.append("project", props.settings.project.id);
    values.append("contact_phone", updatedValues.contact_phone ?? "");
    values.append("contact_person", updatedValues.contact_person ?? "");
    values.append("contact_email", updatedValues.contact_email ?? "");
    values.append("gst_no", updatedValues.gst_no ?? "");
    values.append("pan_no", updatedValues.pan_no ?? "");
    values.append("google_map_address", updatedValues.google_map_address ?? "");
    if (editId) {
      axios
        .put(`${ProjectAddressApi}${editId}/`, values)
        .then((res) => {
          toast.success("Successfully edited address!");
          fetchProjectAddress({ project: props.settings.project.id });
          onClose();
        })
        .catch(() => {});
    } else {
      axios
        .post(`${ProjectAddressApi}`, values)
        .then((res) => {
          toast.success("Successfully added address!");
          fetchProjectAddress({ project: props.settings.project.id });
          onClose();
        })
        .catch(() => {});
    }
  };

  return (
    <React.Fragment>
      <CardBody>
        <ProjectEdit />
        <div className="my-2">
          <hr />
        </div>
        <div className="d-flex justify-content-between">
          <div className="">
            <H6>Address</H6>
          </div>
          <Button
            onClick={(e) => showDrawer()}
            className="btn btn-primary d-flex align-items-center justify-content-center text-white"
          >
            <PlusCircle />
            <div
              style={{
                marginLeft: "4px",
                paddingTop: "4px",
                paddingBottom: "4px",
              }}
            >
              Add Address
            </div>
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={projectAddress}
          pagination={false}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
        />
      </CardBody>
      <Drawer
        title={editId ? "Edit Address" : "Add Address"}
        width={500}
        onClose={() => {
          onClose();
        }}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onClose();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="addressForm"
              type="primary"
              htmlType="submit"
              onClick={addAddress}
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form layout="vertical" id="addressForm" ref={formRef}>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"label"}
                label="Label"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="e.g. Bangalore Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"address"}
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Address is required",
                  },
                ]}
              >
                <TextArea rows={3} placeholder="e.g. Bangalore Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"contact_person"} label="Contact person">
                <Input placeholder="Contact Person" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"contact_phone"} label="Contact phone">
                <Input
                  showCount
                  maxLength={10}
                  minLength={10}
                  placeholder="Phone"
                  type="number"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"contact_email"} label="Contact email">
                <Input placeholder="Contact Email" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"gst_no"} label="GST No.">
                <Input placeholder="GST No." />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Pincode is required",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Pincode"
                  type="number"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"pan_no"} label="PAN">
                <Input placeholder="Pan" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"google_map_address"}
                label="Google Map Address"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="Google Map Address" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(Profile);
